module.exports = __webpack_public_path__ + "img/24.9e6178e3.svg";